import { render, staticRenderFns } from "./Academy.vue?vue&type=template&id=6e7e7906&scoped=true"
import script from "./Academy.vue?vue&type=script&lang=ts"
export * from "./Academy.vue?vue&type=script&lang=ts"
import style0 from "./Academy.vue?vue&type=style&index=0&id=6e7e7906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7e7906",
  null
  
)

export default component.exports